import styles from './SpyLaunchSettingsDialog.module.css'
import { ClickAwayListener, Dialog, Popper } from '@mui/material'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { SpyLaunchSettingsForm } from './presentations/SpyLaunchSettingsForm'
import { useEffect, useRef, useState } from 'react'
import { DateTime } from 'luxon'
import { ApplyButton } from '../../ApplyButton'

interface SpyLaunchSettingsDialogProps {
    open: boolean
    spyLaunchSettings: any
    spy?: any
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
    onSpyLaunchSettingsChange?: (value: any, event: any) => void
    onCancel?: (event: any) => void
}

export const SpyLaunchSettingsDialog = (props: SpyLaunchSettingsDialogProps): JSX.Element => {
    const {
        open,
        spyLaunchSettings,
        spy,
        onClose,
        onSpyLaunchSettingsChange,
    } = props

    const [innerSpyLaunchSettings, setInnerSpyLaunchSettings] = useState<any>(spyLaunchSettings)
    const isXlWidthScreenOrMore = useBreakpointUp('xl')
    const popperInstanceRef = useRef<any>(null)
    const formRef = useRef(null)

    const anchorVirtualElement: any = {
        getBoundingClientRect: () => {
            return {
                width: window.innerWidth,
                height: 0,
                top: 90,
                right: 0,
                bottom: 0,
                left: 0,
            }
        },
    }

    const handleDialogClose = (event: any) => {
        onClose?.(event)
    }

    const handleSpyLaunchSettingsFormSubmit = (value: any, event: any) => {
        setInnerSpyLaunchSettings(value)
    }

    const handlePopperRef = (instance: any) => {
        popperInstanceRef.current = instance
    }

    const handleSpyLaunchSettingsFormRepaint = () => {
        if (popperInstanceRef.current !== null){
            popperInstanceRef.current?.update()
        }
    }

    const handleApplyButtonClick = (event: any) => {
        onSpyLaunchSettingsChange?.(innerSpyLaunchSettings, event)
        onClose?.(event)
    }

    if (isXlWidthScreenOrMore) {
        const popperOptions: any = {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 10],
                    },
                },
            ]
        }

        const handleClickAwayListenerClickAway = (event: any) => {
            onClose?.(event)
        }

        return (
                <Popper
                    className={styles.Popper}              
                    open={open}
                    anchorEl={anchorVirtualElement}
                    popperOptions={popperOptions}
                    popperRef={handlePopperRef}
                >
                    <ClickAwayListener 
                        onClickAway={handleClickAwayListenerClickAway}
                        ref={formRef}
                    >
                        <div>
                            <SpyLaunchSettingsForm 
                                ref={formRef}
                                value={innerSpyLaunchSettings}
                                onSubmit={handleSpyLaunchSettingsFormSubmit}
                                onRepaint={handleSpyLaunchSettingsFormRepaint}
                            />
                           <div 
                                className={styles.Popper__EndContainer}
                            >
                                <ApplyButton 
                                    onClick={handleApplyButtonClick}
                                />
                            </div> 
                        </div>
                    
                    </ClickAwayListener>
                </Popper>
            )
    }

    return (
        <></>
    )
}